import Image from 'next/legacy/image'
import styles from './_storeBanner.module.scss'

import BgImg from '@public/images/store/jazmin-quaynor.png'
import classNames from 'classnames'
import { t } from '../../../utils'
import Link from 'next/link'
import { useAuth } from '../../../utils/auth'

const StoreBanner = () => {
  const { currentUser } = useAuth()

  return (
    <div className={styles.storeBanner}>
      <div className="section">
        <div className="container">
          <div className="columns is-mobile">
            <div
              className={classNames(
                styles.bannerColumn,
                'column is-7-tablet is-offset-5-tablet is-11-mobile is-offset-1-mobile is-relative'
              )}
            >
              <h1>
                Save 50% on the entire store with your Worship Online
                subscription!
              </h1>
              <div>
                <small>
                  From high quality keyboard patches/sounds, to all the
                  individual vocal/multi tracks in different keys, get the tools
                  you need to help you practice and play!
                </small>
              </div>
              {(!currentUser || currentUser?.onFreePlan) && ( //button is not visible for users with regular plan
                <div className={styles.subscribeButton}>
                  <Link
                    href="/store/pre_sign_up"
                    prefetch={false}
                    className="button is-primary is-large is-inline-block is-rectangular"
                  >
                    {t('subscribe now')}
                  </Link>
                  <Link
                    href="/store/songs"
                    prefetch={false}
                    className="button is-primary is-large is-inline-block is-rectangular"
                  >
                    {t('view songs')}
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={styles.bannerImgContainer}>
        <Image
          src={BgImg}
          quality={50}
          priority={true}
          alt="Background Image"
          layout="responsive"
        />
      </div>
    </div>
  )
}

export default StoreBanner
